// Sorting for the model prices list.
const ts = (v) => {
  const t = v ? new Date(v).getTime() : 0;
  return Number.isFinite(t) ? t : 0;
};

const SORTERS = {
  model: (a, b) => String(a.model_pattern || '').localeCompare(String(b.model_pattern || '')),
  provider: (a, b) => String(a.provider || '').localeCompare(String(b.provider || '')),
  last_used: (a, b) => ts(a.last_used) - ts(b.last_used),
  cost: (a, b) => (Number(a.cost) || 0) - (Number(b.cost) || 0),
};
// Text columns start A-Z; time and cost start with the biggest.
export const DEFAULT_DIR = { model: 'asc', provider: 'asc', last_used: 'desc', cost: 'desc' };

/** Sorted copy; ties fall back to model name so the order never jitters. */
export function sortModelRows(rows, { key, dir }) {
  const cmp = SORTERS[key] || SORTERS.last_used;
  const sign = dir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => sign * cmp(a, b) || SORTERS.model(a, b));
}

